/* FileBasedPackageRepository.icon.svg.js */

module.exports = {
    icon: `
            <svg class="center-vertically" viewBox="-227 229 24 24" preserveAspectRatio="none">
                <path class="background-gl" d="M-227,229h24v24h-24V229z"/>
                <path class="foreground-gl" d="M-227,250.6h24v-4.8h-24V250.6z M-224.6,247h2.4v2.4h-2.4V247z M-227,231.4v4.8h24v-4.8H-227z M-222.2,235h-2.4v-2.4h2.4
	                V235z M-227,243.4h24v-4.8h-24V243.4z M-224.6,239.8h2.4v2.4h-2.4V239.8z"/>
            </svg>
         `
};
